import { BorrowerBaseballCard } from '@roc/ui';

export {
  BorrowerBaseballCard
} from '@roc/ui';

export default BorrowerBaseballCard;
